import * as z from "zod";

export const workflowPageViewSchema = z.object({
  workflowId: z.string(),
  workflowName: z.string(),
  spaceSlug: z.string(),
  branchId: z.string().nullable(),
  route: z.string(),
  externalId: z.string().nullable(),
});

export type WorkflowPageView = z.infer<typeof workflowPageViewSchema>;
